import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailArchivedEvent, EmailGet, EnrichedMessage } from '@app/services/email.service';

@Component({
    selector: 'tt-email-archive-dialog',
    templateUrl: './email-archive-dialog.component.html',
    styleUrls: ['./email-archive-dialog.component.css'],
})
export class EmailArchiveDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { get: EmailGet; email: EnrichedMessage }, private dialogRef: MatDialogRef<EmailArchiveDialogComponent>) {}

    public onEmailArchived(event: EmailArchivedEvent) {
        this.dialogRef.close(event);
    }
}
